import { toBaseLink } from '@/lib/transformers'
import { Typo3SectionSpotHeadlessPartners } from '@/types/typo3'

const toSectionPartners = (section: Typo3SectionSpotHeadlessPartners) => ({
  section: section,
  title: section?.content?.title,
  titleLayout: section.content?.titleLayout,
  items: section.content?.items?.map((item) => ({
    id: item.id || '',
    title: item.title,
    subTitle: item?.subtitle,
    link: item.link ? toBaseLink(item.link) : undefined,
    image: item.image
  }))
})

export default toSectionPartners
